export interface Book {
  slug: string;
  title: string;
  subtitle: string;
  author: string;
  category: string;
  description: string;
  coverColor: string;
  coverImage: string;
  isbn: string;
  publicationDate: string;
  purchaseLinks: { label: string; url: string }[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
}

export interface Author {
  slug: string;
  name: string;
}

export interface StoreLink {
  name: string;
  url: string;
  description: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const siteConfig = {
  brandName: '樂律 Lelyric',
  brandDescription: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。',
  brandShortName: '樂律文化',
  brandEnglishName: 'LELYRIC',
  brandCategory: '心理學類書籍',
  brandUrl: 'https://lelyric.sonbook.net/',
  sonbookUrl: 'https://sonbook.net/',
  catalogUrl: 'https://catalog.sonbook.net/',
  blogBooksUrl: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=daiho39',
  canonicalUrl: 'https://lelyric.sonbook.net/',
  contentDisclaimer: '網站所呈現的心理學內容為出版與一般知識資訊，不能取代合格專業人員的評估、診斷與建議。',
  authorDisclaimer: '個別作品內容與作者觀點，不代表樂律文化或崧博出版的官方立場。',
  bookDataNotice: '完整書名、作者、ISBN、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。',
};

export const books: Book[] = [
  {
    slug: 'cold-words-warm-read',
    title: '冷詞熱讀，生僻詞裡的古今人情',
    subtitle: '從經史子集走向鄉鎮飯桌，在詞語的本義與流變中，重讀中華文化的精神根柢',
    author: '何誠斌',
    category: '文化閱讀',
    description:
      '有些詞語蘊含古人的制度與禮法，有些詞留存飯桌上的酒氣與禮法。字裡行間，照見古今相通的人間故事。',
    coverColor: '#e8f4f0',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/c838d203-9171-44f5-b896-a488421a0868_compressed_9786264540131.webp',
    isbn: '9786264540131',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012345' },
    ],
  },
  {
    slug: 'fear-shapes-everyday',
    title: '被恐懼塑造的日常',
    subtitle: '從童年的不安、成年的失控感，到社會與資訊時代的集體焦慮，重新理解恐懼如何形塑我們的一生',
    author: '林予安',
    category: '心理成長',
    description:
      '人生每個階段都在害怕什麼？童年經驗、青春期迷惘、社會壓力、集體焦慮……從成長經驗到生命記憶，恐懼如何塑造出我們的生活樣貌？',
    coverColor: '#2a1a1a',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/bc897a70-7f30-41b2-851a-56f069225873_compressed_9786264540117.webp',
    isbn: '9786264540117',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012346' },
    ],
  },
  {
    slug: 'smallpox-cultural-history',
    title: '天花文化史',
    subtitle: '從神話恐懼到全球勝利的人類對抗史！一種疾病如何翻動帝國與文明的命運？',
    author: '余鳳高',
    category: '歷史人文',
    description:
      '在人類歷史上，有一種疾病，比戰爭更殘酷。它讓孩子滿臉膿皰、終身留疤；讓家庭在幾天之內失去至親；讓城市一夜之間變得死寂。天花，曾是全世界最令人恐懼的名字。',
    coverColor: '#1e3a5f',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/afefb861-6c55-406f-9d94-d7a8eb9dad14_compressed_9786264540063_3D_72dpi.webp',
    isbn: '9786264540063',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012347' },
    ],
  },
  {
    slug: 'parents-take-responsibility',
    title: '當父母拿走責任，孩子只剩下無能',
    subtitle: '用「體貼」代替學習，以「幫忙」取代成長，你那無微不至的愛，正悄悄毒害著他的未來！',
    author: '洪春瑜',
    category: '親子教育',
    description:
      '生活全包、選擇全給、風險全擋……大人件件幫到位，小孩最後什麼都不會。作業太難，乾脆直接幫他寫完？孩子還小，萬事父母決定就好？',
    coverColor: '#fef6e9',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/86fd2464-0ce2-4d71-afb8-5a1c8b5b77dd_compressed_9786264540056_3D_72dpi.webp',
    isbn: '9786264540056',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012348' },
    ],
  },
  {
    slug: 'tuberculosis-cultural-history',
    title: '肺結核文化史',
    subtitle: '一種疾病，千種想像！肺結核如何被書寫、被崇拜、被恐懼？',
    author: '余鳳高',
    category: '歷史人文',
    description:
      '被恐懼的白色死神，也曾是人們迷戀的病態之美？結合醫學、歷史與藝術，一本讀得下去的疾病文化史！',
    coverColor: '#3aa9a5',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/e57b021e-061c-4e5b-90f6-76dcdb040ad1_compressed_9786264540018_3D_72dpi.webp',
    isbn: '9786264540018',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012349' },
    ],
  },
  {
    slug: 'eunuch-next-throne',
    title: '誰讓宦官坐上龍椅旁',
    subtitle: '皇權側門的誕生、失控與終結——帝制最難解的政治循環',
    author: '孟飛',
    category: '歷史人文',
    description:
      '皇帝越想掌控一切，制度越容易崩壞，腐敗就成了必然。五大通道，解剖兩千年惡性循環。',
    coverColor: '#1e3a8a',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/c6eabb3b-d098-485b-86cf-d0b3356a5b60_compressed_9786267699959_3D_72dpi.webp',
    isbn: '9786267699959',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012350' },
    ],
  },
  {
    slug: 'tcm-tumor-treatment',
    title: '中醫腫瘤治療：董洪濤談癌症預防與調養',
    subtitle: '為什麼過度治療可能加速惡化？',
    author: '董洪濤',
    category: '健康養生',
    description:
      '一條不同於主流醫療的中醫路徑，從臨床現場出發，反思手術、化療與過度醫療，揭示真正被忽略的康復關鍵！中醫臨床醫師對癌症本質的深度反思，「扶正氣、養體質」的康復之道。',
    coverColor: '#f5efe6',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/64a36069-d232-444a-bf95-c6d384646270_compressed_9786267699928_3D_72dpi.webp',
    isbn: '9786267699928',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012351' },
    ],
  },
  {
    slug: 'pregnancy-nutrition-diabetes',
    title: '孕期營養與妊娠糖尿病全解 好孕食光',
    subtitle: '從孕期飲食與血糖管理，守護媽媽與寶寶健康',
    author: '龍俊青、夏紅衛',
    category: '孕產育兒',
    description:
      '孕前備孕×飲食營養×體重管理×運動生活，伴妳走過孕前、孕中、產後的每一天。懷孕期間到底該怎麼吃？體重增加多少才算正常？一本書帶妳把複雜的孕期問題，變成每天做得到的選擇！',
    coverColor: '#fdf3e0',
    coverImage:
      'https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/3476c953-c42f-4e12-ad02-1a62400a701d_compressed_9786267699911_3D_72dpi.webp',
    isbn: '9786267699911',
    publicationDate: '2026-01',
    purchaseLinks: [
      { label: '博客來', url: 'https://www.books.com.tw/products/0011012352' },
    ],
  },
];

export const categories: Category[] = [];

export const authors: Author[] = [];

export const navItems = [
  { label: '首頁', path: '/' },
  { label: '品牌介紹', path: '/about' },
  { label: '合作通路', path: '/stores' },
  { label: '常見問題', path: '/faq' },
  { label: '閱讀推薦', path: '/blog' },
];

export const footerLinks = [
  {
    title: '品牌',
    links: [
      { label: '品牌介紹', path: '/about' },
      { label: '合作通路', path: '/stores' },
      { label: '常見問題', path: '/faq' },
      { label: '閱讀推薦', path: '/blog' },
    ],
  },
  {
    title: '外部資源',
    links: [
      { label: '書籍資料庫', path: siteConfig.catalogUrl, external: true },
      { label: '崧博出版', path: siteConfig.sonbookUrl, external: true },
      { label: '博客來品牌書目', path: siteConfig.blogBooksUrl, external: true },
    ],
  },
];

export const contactSubjects = [
  '書籍問題',
  '購書問題',
  '版權問題',
  '作者或內容合作',
  '品牌經銷與合作方案',
  '媒體與活動',
  '其他',
];

export const storeLinks: StoreLink[] = [
  {
    name: '博客來品牌書目',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=daiho39',
    description: '在博客來查看樂律出版書籍',
  },
  {
    name: '崧博出版',
    url: 'https://sonbook.net/',
    description: '崧博出版事業有限公司官方網站',
  },
  {
    name: '崧博出版書籍資料庫',
    url: 'https://catalog.sonbook.net/',
    description: '查詢完整書名、作者、ISBN 及出版資訊',
  },
];

export const faqItems: FaqItem[] = [
  {
    question: '樂律是什麼品牌？',
    answer: '樂律文化為獨立出版品牌，本品牌委託崧博出版經銷，官方網站由崧博出版製作。樂律文化以心理學類書籍為主要出版方向。',
  },
  {
    question: '樂律與崧博出版的關係？',
    answer: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。委託經銷與網站製作，不代表樂律文化是崧博旗下品牌、子品牌或自有品牌。完整書目可前往崧博出版書籍資料庫查詢。',
  },
  {
    question: '如何查詢完整書目與書籍資料？',
    answer: '正式書名、作者、ISBN、出版日期等資訊，請前往崧博出版書籍資料庫（catalog.sonbook.net）查詢。',
  },
  {
    question: '如何購買樂律出版的書籍？',
    answer: '可前往合作通路頁面查看已建立的購買連結，或前往崧博出版書籍資料庫查詢相關資訊。',
  },
  {
    question: '如何聯絡合作洽詢？',
    answer: '品牌經銷與合作方案詳情，請前往崧博出版官網（sonbook.net）了解或直接聯繫洽詢。',
  },
];
